<template>
  <div>
    <q-field
        style="width: 300px;"
    >
      <q-input
          v-model="manager.email"
          @click="editUser(manager)"
          @input="search"
          @focus="$event => selectText($event)"
          placeholder="Введите ФИО/Email клиента"
          ref="input"
      />

      <q-popover
          v-model="searchOpened"
          :no-focus="true"
          :no-refocus="true"
          :anchor-click="false"
          anchor="bottom left"
          self="top left"
          :offset="[0, -5]"
          max-height="300px"
      >
        <q-infinite-scroll
            :handler="loadMoreUsers"
            :offset="20"
        >
          <q-list no-border>
            <q-item
                v-for="(user, index) in usersList"
                :key="index"
                @click.native="selectUser(user)"
                link
            >
              {{ user.first_name }} {{ user.last_name }} <{{ user.email }}>
            </q-item>
          </q-list>

          <div class="row justify-center">
            <q-spinner-dots
                v-show="loading"
                :size="25"
            />
          </div>
        </q-infinite-scroll>

        <div
            v-if="!usersList.length"
            class="q-ma-md"
        >
          <span style="font-style: italic; font-size: 12px;">Клиент не найден</span>
        </div>

        <div class="q-ma-md">
          <q-btn
              @click="createNewUser"
              label="Добавить нового клиента"
          />
        </div>
      </q-popover>
    </q-field>

    <user-create
        v-model="newUserModalOpened"
        @create="user => $emit('userChanged', user)"
        @close="$refs.input.focus()"
    />
  </div>
</template>

<script>
import {
  QField,
  QInput,
  QToggle,
  QBtn,
  QTooltip,
  QPopover,
  QList,
  QItem,
  QInfiniteScroll,
  QSpinnerDots,
} from 'quasar';

import UserCreate from "../UserCreate/UserCreate";

export default {
  name: "ProjectUserInput",

  props: {
    manager: {
      type: Object,
      required: true,
    }
  },

  components: {
    QField,
    QInput,
    QToggle,
    QBtn,
    QTooltip,
    QPopover,
    QList,
    QItem,
    QInfiniteScroll,
    QSpinnerDots,
    UserCreate,
  },

  data() {
    return {
      editMode: false,
      searchOpened: false,
      newOwnerName: null,
      newOwnerId: null,
      newOwnerData: '',
      query: '',
      usersList: [],
      usersListPage: 1,
      usersListPagesCount: 1,
      canSave: false,
      loading: false,
      ownerTempName: null,
      newUserModalOpened: false,
      inputDelay: 500,
      inputDelayTimer: null,
      currentManagerEmail: null,
    }
  },

  methods: {
    search(value) {
      if (value.length < 2){
        this.searchOpened = false
        return
      }

      this.inputDelayTimer = setTimeout(() => {
        this.query = value;
        this.usersList = [];
        this.usersListPage = 1;
        this.findUser(value);
      }, this.inputDelay);
    },

    selectUser(user) {
      this.$emit('userChanged', user)
      this.searchOpened = false;

      setTimeout(() => {
        this.$refs.input.focus();
        this.$refs.input.$refs.input.select();
      })
    },

    selectText($event) {
      $event.target.select();
    },

    editUser(manager) {
      this.editMode = true;
      this.currentManagerEmail = manager
    },

    discardChanges() {
      this.editMode = false;
    },

    createNewUser() {
      this.$emit('setUserLastName', this.manager.email);
      this.searchOpened = false;
      this.newUserModalOpened = true;
    },

    findUser(query, page = 1) {
      this.loading = true;

      return this.$http.get(`api/v1.0/users/?filter[role]=user&filter[search]=${query}&page=${page}`).then(response => {
        this.usersList = [...this.usersList, ...response.data.users];
        this.usersListPagesCount = response.data.pagesCount;
        this.searchOpened = true;
        this.loading = false;
      });
    },

    loadMoreUsers(_i, done) {
      if (this.usersListPagesCount > this.usersListPage) {
        this.findUser(this.query, ++this.usersListPage).then(() => done());
      } else {
        done();
      }
    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProjectUsersList/ProjectUserInput.vue